import { useLogout } from '@/modules/auth/hooks';

import { LocalStorageKeys } from '../constants';
import { useRefreshToken } from './useRefreshToken';

export type FetchOptions = {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: BodyInit | null;
  asFormData?: boolean;
  responseType?: 'json' | 'blob';
};

export function useFetch() {
  const logoutUser = useLogout();
  const refreshToken = useRefreshToken();

  const fetchClient = async (url: string, options?: FetchOptions) => {
    const baseUrl = `${import.meta.env.VITE_BASE_API_URL}${url}`;
    const token = localStorage.getItem(LocalStorageKeys.AccessToken);
    const isBlob = options?.responseType === 'blob';

    if (!token) {
      logoutUser();
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    if (!options?.asFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const rawResponse = await fetch(baseUrl, {
      headers,
      ...options,
    });

    if (rawResponse.status === 401) {
      return await refreshToken(async () => await fetchClient(url, options));
    }

    if (rawResponse.status === 500) {
      throw new Error('Internal Server Error');
    }

    const response = isBlob
      ? await rawResponse.blob()
      : await rawResponse.json();

    if (response?.error?.message) {
      throw new Error(response?.error?.message);
    }

    return isBlob ? response : response.data;
  };

  return fetchClient;
}
